import { useState } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { newId } from '@abastece/shared';
import { db } from '../db/dexie.js';
import { emitir } from '../lib/emitir.js';
import { usePuede } from '../lib/sesion.js';
import { Campo } from '../ui/Campo.js';
import { Pagina } from '../ui/Pagina.js';
import { Ico } from '../ui/Iconos.js';
import { useT } from '../i18n/index.js';
import { etiquetaListaPrecio } from '../lib/catalogo.js';

export function ListasPrecio() {
  const t = useT();
  const listas = useLiveQuery(() => db.listas.toArray(), [], []);
  const precios = useLiveQuery(() => db.precios.toArray(), [], []);
  const puede = usePuede('editar_precios');
  const [nombre, setNombre] = useState('');

  const ordenadas = [...listas].filter((l) => l.activa).sort((a, b) => a.orden - b.orden);

  async function crear() {
    if (!nombre.trim()) return;
    await emitir('lista_precio.creada', {
      listaId: newId(),
      nombre: nombre.trim(),
      esPredeterminada: ordenadas.length === 0,
      orden: ordenadas.length,
    });
    setNombre('');
  }

  async function hacerPredeterminada(listaId: string) {
    for (const l of ordenadas) {
      if (l.esPredeterminada && l.id !== listaId) {
        await emitir('lista_precio.actualizada', { listaId: l.id, esPredeterminada: false });
      }
    }
    await emitir('lista_precio.actualizada', { listaId, esPredeterminada: true });
  }

  return (
    <Pagina
      titulo={t('listas.titulo')}
      subtitulo={t('listas.subtitulo')}
      volverA="/precios"
    >
      <ul className="mb-4 flex flex-col gap-2">
        {ordenadas.map((l) => (
          <li key={l.id} className="tarjeta flex items-center justify-between gap-4">
            <div>
              <p className="font-medium">{etiquetaListaPrecio(l)}</p>
              <p className="mt-0.5 text-xs text-slate-500">
                {t('listas.preciosDefinidos', {
                  n: precios.filter((p) => p.listaId === l.id).length,
                })}
              </p>
            </div>
            {l.esPredeterminada ? (
              <span className="shrink-0 rounded-lg bg-marca-600/20 px-2.5 py-1 text-xs text-marca-500">
                {t('listas.predeterminada')}
              </span>
            ) : (
              puede && (
                <button
                  type="button"
                  className="btn-texto shrink-0 gap-1 text-xs text-slate-500"
                  onClick={() => void hacerPredeterminada(l.id)}
                >
                  <Ico icono="marca" className="size-3.5" />
                  {t('listas.hacerPredeterminada')}
                </button>
              )
            )}
          </li>
        ))}
      </ul>

      {puede && (
        <section className="tarjeta flex items-end gap-3">
          <div className="flex-1">
            <Campo
              maxLength={40}
              etiqueta={t('listas.nueva')}
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder={t('listas.ejemplo')}
              autoComplete="off"
              onKeyDown={(e) => e.key === 'Enter' && void crear()}
            />
          </div>
          <button
            type="button"
            className="btn-secundario"
            disabled={!nombre.trim()}
            onClick={() => void crear()}
          >
            <Ico icono="agregar" />
            {t('comun.agregar')}
          </button>
        </section>
      )}

      <p className="mt-4 text-xs text-slate-500">
        {t('listas.explicacion')}
      </p>
    </Pagina>
  );
}
